export const pedirData = {
  flyers: [
    {
      id: 'impresion',
      name: 'Flyer para Impresión',
      description: 'Diseño optimizado para impresión con alta resolución, perfecto para eventos, promociones o restaurantes.',
      price: '$25',
    },
    {
      id: 'redessociales',
      name: 'Flyer para Redes Sociales',
      description: 'Diseño adaptado para plataformas sociales con formato cuadrado o vertical, ideal para promociones online.',
      price: '$20',
    },
  ],
  video: [
    {
      id: 'edicion',
      name: 'Solo Edición',
      description: 'Edición profesional de tu material grabado. Entrega en formato optimizado para redes sociales con corrección de color y audio.',
      price: '$35',
    },
    {
      id: 'grabacion',
      name: 'Grabación',
      description: 'Sesión de grabación profesional con equipo de calidad.',
      price: '$75',
    },
  ],
};
